import React, { Component } from 'react';
import firebase from '../helper/firebase';

import validator from 'email-validator';

import { ReactGoogleAnalytics, GetToken } from '../helper/functions';

import { Primary } from '../helper/consts';

import {
	Avatar,
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Divider,
	IconButton,
	LinearProgress,
	TextField,
	Typography
} from 'material-ui';

import OfferSharedRecipientsCard from '../components/OfferSharedRecipientsCard';

import SendIcon from 'material-ui-icons/Send';
import StarIcon from 'material-ui-icons/Star';
import StarBorderIcon from 'material-ui-icons/StarBorder';

import Fade from 'material-ui/transitions/Fade';

const style = {
	emailShareForm: {
		flexWrap: 'wrap',
		display: 'flex',
		width: '100%',
		alignItems: 'baseline'
	},
	emailInput: {
		flexGrow: '1',
		marginRight: '15px'
	},
	aboutInput: {
		flexGrow: '2',
		width: '100%'
	},
	emailSendButton: {
		marginLeft: '15px'
	},
	rating: {
		flexGrow: '0',
		marginTop: '16px',
		marginBottom: '8px',
		backgroundColor: '#eeeeee',
		color: 'rgba(135,135,135,1)',
		borderRadius: '3px'
	},
	star: {
		fill: Primary
	}
};

export default class EmailShareCard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			oid: this.props.oid,
			jid: this.props.jid,
			uid: this.props.uid,
			recipientEmail: '',
			recipientAbout: '',
			rating: null,
			recipients: {},
			loading: true
		};
	}

	componentDidMount = () => {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.getRecipients(user.uid);
				this.setState({ uid: user.uid });
			} else {
				this.state.uid &&
					this.state.oid &&
					firebase
						.database()
						.ref(`myInvites/${this.state.uid}/${this.state.oid}`)
						.off();
				this.setState({
					oid: '',
					jid: '',
					uid: '',
					recipientEmail: '',
					recipientAbout: '',
					rating: null,
					recipients: {},
					loading: true
				});
			}
		});
	};

	componentWillUnmount() {
		this.state.uid &&
			this.state.oid &&
			firebase
				.database()
				.ref(`myInvites/${this.state.uid}/${this.state.oid}`)
				.off();
	}

	getRecipients = uid => {
		const ref = firebase.database().ref();
		ref.child(`myInvites/${uid}/${this.state.oid}`).on(
			'value',
			recipientsSnap => {
				if (recipientsSnap.val() !== null) {
					this.setState({
						recipients: recipientsSnap.val(),
						loading: false
					});
				} else {
					this.setState({
						recipients: {},
						loading: false
					});
				}
			},
			recipientsErr => {
				this.setState({
					recipients: {},
					loading: false,
					snackStatus: true,
					snackMessage: `Error: There was an error. Please try again.`
				});
			}
		);
	};

	handleChange = name => event => {
		if (name === 'recipientEmail') {
			let status = validator.validate(event.target.value);
			this.setState({
				[name]: event.target.value,
				[`${name}Error`]: !status
			});
		} else {
			this.setState({
				[name]: event.target.value,
				[`${name}Error`]: false
			});
		}
	};

	validationError = state =>
		this.setState({ [`${state}`]: true, emailSending: false });

	validateRecipientEmail = e => {
		this.setState({ emailSending: true });
		const { recipientEmail, recipientAbout } = this.state;
		if (
			recipientEmail.length < 1 ||
			recipientEmail.indexOf('@') === -1 ||
			recipientEmail.indexOf('.') === -1 ||
			recipientEmail.length === 0
		) {
			return this.validationError('recipientEmailError');
		} else if (recipientAbout.length === 0) {
			return this.validationError('recipientAboutError');
		} else {
			this.checkRecipientEmailStatus();
		}
	};

	checkRecipientEmailStatus = () => {
		const { recipientEmail, recipients } = this.state;
		let counter;
		!!recipients ? (counter = Object.keys(recipients).length) : (counter = 0);
		if (counter !== 0) {
			for (let recipientObj in recipients) {
				const recipient = recipients[recipientObj];
				if (recipient.recipientEmail === recipientEmail) {
					this.setState({
						snackStatus: true,
						snackMessage: 'Error. Invite Already Sent to That Email.',
						emailSending: false
					});
					return;
				}
				counter--;
				if (counter === 0) {
					this.sendInvitation();
				}
			}
		} else {
			this.sendInvitation();
		}
	};

	sendInvitation = () => {
		const {
			recipientEmail,
			recipientAbout,
			jid,
			oid,
			uid,
			rating
		} = this.state;
		const body = {
			recipientEmail,
			recipientAbout,
			rating,
			jid,
			uid,
			oid
		};
		this.setState({ emailSending: true });
		GetToken()
			.then(token => {
				const url = `https://us-central1-talent-7d36f.cloudfunctions.net/invitation`;
				const options = {
					method: 'post',
					body: JSON.stringify(body),
					headers: {
						Authorization: 'Bearer ' + token
					}
				};
				fetch(url, options)
					.then(res => {
						ReactGoogleAnalytics('Offers', 'Share', oid, null, null);
						ReactGoogleAnalytics('Jobs', 'Share', jid, null, null);
						this.setState({
							snackStatus: true,
							snackMessage: 'Email Invite Sent!',
							emailSending: false,
							recipientEmail: '',
							recipientAbout: '',
							rating: null
						});
					})
					.catch(err => {
						this.setState({
							snackStatus: true,
							snackMessage: 'Error: please try again.',
							emailSending: false
						});
					});
			})
			.catch(tokenError => {
				this.setState({
					snackStatus: true,
					snackMessage: 'Error: please try again.',
					emailSending: false
				});
			});
	};

	render() {
		// console.log(this.state);
		const { loading } = this.state;
		return (
			<Fade key={'emailPeople'} in={true}>
				<Card className={!!loading ? 'card skeletonCard' : 'card'}>
					<CardHeader
						title={!!loading ? ' ~ ' : null}
						subheader={
							!!loading ? ' ~ ' : 'Enter email address of offer recipient.'
						}
						classes={{
							title: !!loading ? 'titleSkeleton' : null,
							subheader: !!loading ? 'subheaderSkeleton' : null
						}}
						avatar={!!loading ? <Avatar className="avatarSkeleton" /> : null}
					/>
					<Divider light />
					<CardContent>
						{!!loading ? (
							<React.Fragment>
								<Typography className="titleSkeleton"> ~ </Typography>
								<Typography className="titleSkeleton"> ~ </Typography>
								<Typography className="titleSkeleton"> ~ </Typography>
							</React.Fragment>
						) : (
							<div style={style.emailShareForm}>
								<TextField
									required
									type="email"
									id="recipientEmail"
									label="Email Address"
									placeholder="Email..."
									margin="normal"
									helperText={
										this.state.recipientEmailError
											? 'Please check the email address format'
											: null
									}
									error={this.state.recipientEmailError}
									onChange={this.handleChange('recipientEmail')}
									value={this.state.recipientEmail}
									disabled={this.state.emailSending}
									style={style.emailInput}
								/>
								<div style={style.rating} className="rating">
									{[1, 2, 3, 4, 5].map(rating => {
										return (
											<IconButton
												key={rating}
												onClick={() => {
													this.setState({ rating: rating });
												}}
												aria-label={`Rating: ${rating}`}
												disabled={this.state.emailSending}
											>
												{this.state.rating >= rating ? (
													<StarIcon style={style.star} />
												) : (
													<StarBorderIcon style={style.star} />
												)}
											</IconButton>
										);
									})}
								</div>
								<TextField
									required
									type="text"
									id="recipientAbout"
									label="About Recipient"
									placeholder="About recipient..."
									margin="normal"
									multiline
									helperText={
										this.state.recipientAboutError
											? 'Please check the email address format'
											: null
									}
									error={this.state.recipientAboutError}
									onChange={this.handleChange('recipientAbout')}
									value={this.state.recipientAbout}
									disabled={this.state.emailSending}
									style={style.aboutInput}
								/>
							</div>
						)}
					</CardContent>
					<CardActions className="cardActions">
						<Button
							className={
								!!loading ? 'cardActionsBtn avatarSkeleton' : 'cardActionsBtn'
							}
							onClick={this.validateRecipientEmail}
							raised={
								this.state.recipientEmail.length !== 0 &&
								this.state.recipientAbout.length !== 0
							}
							style={style.emailSendButton}
							disabled={
								loading ||
								this.state.emailSending ||
								!(
									this.state.recipientEmail.length !== 0 &&
									this.state.recipientAbout.length !== 0
								)
							}
							type="submit"
							dense
							color="default"
							aria-label="copy"
						>
							<SendIcon />
						</Button>
					</CardActions>
					<LinearProgress
						style={this.state.sending ? { opacity: 1 } : { opacity: 0 }}
						mode={this.state.sending ? 'indeterminate' : 'determinate'}
						value={0}
					/>
					<Divider light />
					{!loading && (
						<OfferSharedRecipientsCard recipients={this.state.recipients} />
					)}
				</Card>
			</Fade>
		);
	}
}

// mount
//   oid
//   offer/oid
//   jid
//   jobs/jid
//   myOffers/uid/jid
//   getOID old or new
//   getFavAndInviteInfo
//
//   reqd jid,uid,oid



// WEBPACK FOOTER //
// ./src/components/EmailShareCard.js